import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    jobs: [],
    fetchingJobs: true,
    job: null,
    fetchingJob: false,
    jobsResultInfo: null,
    fetchingJobStatuses: false,
    jobFilters: [],
    jobStatuses: [],
    creatingJob: false,
    cancelingJob: false,
    gettingJobTimings: false,
    gettingJobFilters: false,
    jobModel: {},
  },
  getters: {
    projectId: () => store.state.app.projectId,
  },
  mutations: {
    SET_JOBS(state, res) {
      state.jobs = res.result
      state.jobsResultInfo = res.resultInfo
    },
    SET_FETCHING_JOBS(state, value) {
      state.fetchingJobs = value
    },
    SET_JOB(state, value) {
      state.job = value
    },
    SET_FETCHING_JOB(state, value) {
      state.fetchingJob = value
    },
    SET_FETCHING_JOB_STATUSES(state, value) {
      state.fetchingJobStatuses = value
    },
    SET_JOB_STATUSES(state, value) {
      state.jobStatuses = value
    },
    SET_CREATING_JOB(state, value) {
      state.creatingJob = value
    },
    SET_CANCELING_JOB(state, value) {
      state.cancelingJob = value
    },
    SET_GETTING_JOB_TIMINGS(state, value) {
      state.gettingJobTimings = value
    },
    SET_GETTING_JOB_FILTERS(state, value) {
      state.gettingJobFilters = value
    },
    SET_JOB_FILTERS(state, value) {
      state.jobFilters = value?.jobTemplateOptions
    },
    SET_JOB_MODEL(state) {
      state.jobModel = {
        initialized: false,
        noDestinations: true,
        gjBlob: null,
        filePath: '',
        callbackUrl: '',
        destination: '',
        destinationOptions: [
          {
            value: null,
            text: 'Select',
          },
        ],
        generateThumbnail: true,
        jobTags: [],
      }
    },
  },
  actions: {
    fetchJobs({ commit }, payload) {
      const pageIndex = `pageIndex=${payload.pageIndex || 0}`
      const status = `status=${payload.status}`
      const searchTerm = `${
        payload.searchTerm ? `searchTerm=${payload.searchTerm}` : ''
      }`
      const query = `?pageSize=10&${pageIndex}&${status}&${searchTerm}`
      commit('SET_FETCHING_JOBS', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/jobs${query}`)
          .then(response => {
            commit('SET_JOBS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_JOBS', false)
          })
      })
    },
    fetchJob({ commit }, payload) {
      const name = payload
      commit('SET_FETCHING_JOB', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/jobs/${name}`)
          .then(response => {
            commit('SET_JOB', response.data.result)
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_JOB', false)
          })
      })
    },
    refreshOutputGroupTweak({ commit }, payload) {
      const name = payload
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/jobs/${name}`)
          .then(response => {
            commit('SET_JOB', response.data.result)
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    fetchJobStatuses({ commit }) {
      commit('SET_FETCHING_JOB_STATUSES', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/jobs/statuses`)
          .then(response => {
            const filters = response.data
            commit('SET_JOB_STATUSES', filters.jobStatusOptions)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_JOB_STATUSES', false)
          })
      })
    },
    createJob({ commit }, job) {
      commit('SET_CREATING_JOB', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .post(`projects/${getProjectId()}/jobs`, job)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_CREATING_JOB', false)
          })
      })
    },
    cancelJob({ commit }, id) {
      commit('SET_CANCELING_JOB', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .put(`projects/${getProjectId()}/jobs/${id}/cancel`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_CANCELING_JOB', false)
          })
      })
    },
    getJobTiming({ commit }, query) {
      const { jobId } = query
      const outputId = query.outputId ? `?outputId=${query.outputId}` : ''
      commit('SET_GETTING_JOB_TIMINGS', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/jobs/${jobId}/timings${outputId}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_JOB_TIMINGS', false)
          })
      })
    },
    restartEncodingOutput({ commit }, query) {
      const { jobId } = query
      const outputId = query.outputId ? `?outputJobId=${query.outputId}&type=1` : ''
      commit('RESTART_ENCODING_OUTPUTS', true)
      return new Promise((resolve, reject) => {
        api('encoder')
          .post(`projects/${getProjectId()}/jobs/${jobId}/encoding-outputs${outputId}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('RESTART_ENCODING_OUTPUTS', false)
          })
      })
    },
    getJobFilters({ commit }) {
      commit('SET_GETTING_JOB_FILTERS', false)
      return new Promise((resolve, reject) => {
        api('encoder')
          .get(`projects/${getProjectId()}/jobs/filters/`)
          .then(response => {
            commit('SET_JOB_FILTERS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_JOB_FILTERS', false)
          })
      })
    },
    resetJob({ commit }) {
      commit('SET_JOB', null)
    },
  },
}
